import theme from "@/theme";
import { CompositeDecorator, ContentBlock } from "draft-js";
import LoadingSvg from "@/assets/svg/LoadingSvg";
import { useState } from "react";

export const fontSizeOptions = ["12", "14", "16", "18", "20", "22", "24", "28", "32", "36"];

export const fontSizeStyles = {
  "FONTSIZE-12": { fontSize: "12px" },
  "FONTSIZE-14": { fontSize: "14px" },
  "FONTSIZE-15": { fontSize: "15px" },
  "FONTSIZE-16": { fontSize: "16px" },
  "FONTSIZE-18": { fontSize: "18px" },
  "FONTSIZE-20": { fontSize: "20px" },
  "FONTSIZE-22": { fontSize: "22px" },
  "FONTSIZE-24": { fontSize: "24px" },
  "FONTSIZE-28": { fontSize: "28px" },
  "FONTSIZE-32": { fontSize: "32px" },
  "FONTSIZE-36": { fontSize: "36px" },
  "fontsize-12": { fontSize: "12px" },
  "fontsize-14": { fontSize: "14px" },
  "fontsize-16": { fontSize: "16px" },
  "fontsize-18": { fontSize: "18px" },
  "fontsize-20": { fontSize: "20px" },
  "fontsize-24": { fontSize: "24px" },
  "fontsize-28": { fontSize: "28px" },
  "fontsize-32": { fontSize: "32px" },
};

export const safeAppend = (formData: FormData, key: string, value: any) => {
  if (value === undefined || value === null) return;

  let finalValue = value;

  if (typeof value === "boolean" || typeof value === "number") {
    finalValue = value.toString();
  }

  formData.append(key, finalValue);
};

const Media = (props: any) => {
  const entity = props.contentState.getEntity(props.block.getEntityAt(0));
  const data = entity.getData();
  const [imgLoaded, setImgLoaded] = useState(false);

  if (data.loading) {
    return (
      <div
        style={{
          width: "100%",
          height: "22.875rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "transparent",
          borderRadius: "16px",
          marginTop: "50px",
          marginBottom: "50px",
        }}
      >
        <LoadingSvg width={42} height={42} color="#2A85FF" />
      </div>
    );
  }

  const { src } = data;
  return (
    <div style={{ width: "100%", marginTop: "50px", marginBottom: "50px", position: "relative" }}>
      {!imgLoaded && (
        <div
          style={{
            width: "100%",
            height: "22.875rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "transparent",
            borderRadius: "16px",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        >
          <LoadingSvg width={42} height={42} color="#2A85FF" />
        </div>
      )}
      <img
        src={src}
        alt="inserted"
        onLoad={() => setImgLoaded(true)}
        style={{
          width: "800px",
          height: "430px",
          objectFit: "fill",
          borderRadius: "16px",
          opacity: 1,
          border: "1px solid transparent",
          display: imgLoaded ? "block" : "none",
        }}
      />
    </div>
  );
};
export const mediaBlockRenderer = (block: ContentBlock) => {
  if (block.getType() === "atomic") {
    return {
      component: Media,
      editable: false,
    };
  }
  return null;
};

const DollarHashtagSpan = (props: any) => (
  <span
    style={{
      color: theme.palette.custom.mainBlue,
      // fontWeight: 500,
      fontSize: "inherit",
      lineHeight: "inherit",
    }}
  >
    {props.children}
  </span>
);

const LinkSpan = (props: any) => (
  <a
    href={props.decoratedText}
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: theme.palette.custom.mainBlue }}
  >
    {props.children}
  </a>
);

const regexStrategy = (regex: RegExp) => (contentBlock: any, callback: any, _contentState: any) => {
  const text = contentBlock.getText();
  let matchArr, start;
  while ((matchArr = regex.exec(text)) !== null) {
    start = matchArr.index;
    callback(start, start + matchArr[0].length);
  }
};

export const decorator = new CompositeDecorator([
  {
    strategy: regexStrategy(/\$[a-zA-Z]{1,}/g),
    component: DollarHashtagSpan,
  },
  {
    strategy: regexStrategy(/https?:\/\/[^\s]+/g),
    component: LinkSpan,
  },
]);
